import React, { useContext } from 'react';
import '../App.css';
import CSS from 'csstype';
import { useAppSelector } from '../app/hooks';

// functions

// images
import {
  Bug,
  CircleAlert,
  CircleCheck,
  CircleQuestionMark,
  CircleX,
  Cog,
  Info,
  SquareArrowRightExit,
} from 'lucide-react';

// classes

//  --------------------------------------------------------------------------
//
//  P R O P E R T I E S
//
//  --------------------------------------------------------------------------

//  --------------------------------------------------------------------------
//
//  H T M L   C U S T O M   C O M P O N E N T S
//
//  --------------------------------------------------------------------------

//  --------------------------------------------------------------------------
//
//  C L A S S   D E F I N I T I O N
//
//  --------------------------------------------------------------------------

//  ------------------------------------------------------------
//
//  Parameters:
//
//  status: the text to display.
//
//  ------------------------------------------------------------

export default function StatusIndicator(props: { status: string }) {
  //
  //  --------------------------------------------------------------------------
  //
  //  R E D U X   S T A T E   H A N D L I N G
  //
  //  --------------------------------------------------------------------------

  const sG_DarkMode: boolean = useAppSelector((state) => state.global.darkMode);

  //  --------------------------------------------------------------------------
  //
  //  F U N C T I O N S
  //
  //  --------------------------------------------------------------------------

  //  -------------------------------------------------
  //
  //  set the colour of the job status
  //
  //  -------------------------------------------------

  function itemColour(args: { status: string; darkMode?: boolean }) {
    //
    var colour: string = 'TRANSPARENT';

    if (args.status.toUpperCase() === 'STAGING') colour = 'BLUE';
    if (args.status.toUpperCase() === 'RETRYING') colour = 'ORANGE';
    if (args.status.toUpperCase() === 'COMPLETED') colour = 'GREEN';
    if (args.status.toUpperCase() === 'REVOKED') colour = 'RED';
    if (args.status.toUpperCase() === 'FAILED') colour = 'RED';
    if (args.status.toUpperCase() === 'ERROR') colour = 'RED';
    if (args.status.toUpperCase() === 'RUNNING') colour = 'GREEN';
    if (args.status.toUpperCase() === 'STOPPED') colour = 'RED';
    if (args.status.toUpperCase() === 'UNKNOWN') colour = 'TRANSPARENT';
    if (args.status.toUpperCase() === 'CRITICAL') colour = 'RED';
    if (args.status.toUpperCase() === 'WARNING') colour = 'ORANGE';
    if (args.status.toUpperCase() === 'INFO') colour = 'BLUE';
    if (args.status.toUpperCase() === 'DEBUG') colour = 'GREEN';
    if (args.status.toUpperCase() === 'NOTSET') colour = 'TRANSPARENT';

    // return something.
    return colour;
    //
  } // itemColour

  //  -------------------------------------------------
  //
  //  set the icon of the job status
  //
  //  -------------------------------------------------

  function ItemIcon(args: { status: string }) {
    //
    const SIZE: number = 25;

    switch (args.status.toUpperCase()) {
      case 'STAGING':
      case 'RETRYING':
        return <SquareArrowRightExit width={SIZE} height={SIZE} strokeWidth={1.5} />;
      case 'COMPLETED':
        return <CircleCheck width={SIZE} height={SIZE} strokeWidth={1.5} />;
      case 'RUNNING':
        return <Cog width={SIZE} height={SIZE} strokeWidth={1.5} />;
      case 'REVOKED':
        return <CircleX width={SIZE} height={SIZE} strokeWidth={1.5} />;
      case 'FAILED':
      case 'ERROR':
      case 'STOPPED':
      case 'CRITICAL':
      case 'WARNING':
        return <CircleAlert width={SIZE} height={SIZE} strokeWidth={1.5} />;
      case 'INFO':
        return <Info width={SIZE} height={SIZE} strokeWidth={1.5} />;
      case 'DEBUG':
        return <Bug width={SIZE} height={SIZE} strokeWidth={1.5} />;
      default:
        return <CircleQuestionMark width={SIZE} height={SIZE} strokeWidth={1.5} />;
    }
    //
  } // ItemIcon

  //  --------------------------------------------------------------------------
  //
  //  C O M P O N E N T   C O D E
  //
  //  --------------------------------------------------------------------------

  const ITEM_COLOUR: string = itemColour({ status: props.status });

  return (
    <div
      className="status-indicator"
      data-colour={ITEM_COLOUR}
      style={{
        flex: '0 0 180px',
        textAlign: 'center',
        width: '180px',
        height: '40px',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <div
        className="text-colour"
        style={{ flex: '0 0 20px', display: 'flex', marginLeft: '5px' }}
      >
        <ItemIcon status={props.status} />
      </div>
      <div
        className="text-colour"
        style={{
          flex: '1 1',
          fontWeight: '400',
        }}
      >
        {props.status}
      </div>
      <div style={{ flex: '0 0 10px' }} />
    </div>
  );
  //
} // StatusIndicator
